// extracted by mini-css-extract-plugin
export default {"Container":"payroll_Container__osj8o","section-1":"payroll_section-1__Qcqhe","content":"payroll_content__CXUGS","section-2":"payroll_section-2__DzUwV"};